import { useQuery } from '@tanstack/react-query';

import { DATA_INIT_CACHING } from '@/configs/query';
import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useParticipantsGeoAreaApi } from '@/features/api/hooks/participant-geo-area/useParticipantsGeoAreaApi';
import { isEmptyOrNull } from '@/shared/utils/string';

export const useGetGeoArea = (
  geoAreaId = '',
  options: { includeAncestors?: boolean } = {}
) => {
  const { includeAncestors } = options;
  const api = useParticipantsGeoAreaApi();
  return useQuery({
    queryKey: [API_CACHE_KEYS.GEO_AREA, geoAreaId, { includeAncestors }],
    queryFn: () => api.getGeoArea({ geoAreaId, includeAncestors }),
    enabled: !isEmptyOrNull(geoAreaId),
    ...DATA_INIT_CACHING
  });
};
